import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import { useAuthContext } from "../../context/AuthContext";
import UserTimeClockPanel from "../Settings/Users/UserTimeClockPanel";

/**
 * Self-service do colaborador: espelho, ciência, justificativa e marcação manual.
 */
export default function MyTimeClockPage() {
  const { userData } = useAuthContext();
  const userId = userData?.id != null ? Number(userData.id) : null;

  if (!userId) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="warning">Faça login para ver seu ponto.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 960, mx: "auto" }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Consulte seu registro conforme o tipo de contrato. Quem tem jornada, estágio ou Outro com
        horário registra marcações; prestador, função de confiança e Outro sem ponto não têm ponto.
        O RH revisa pedidos em Configurações → Controle de Ponto.
      </Typography>
      <UserTimeClockPanel
        userId={userId}
        userName={userData?.nome || userData?.name}
        selfMode
        showMatricula={false}
        showManualMark
        showAdjustment
      />
    </Box>
  );
}
